
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","viewBox":"0 0 30 30","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"nonzero"}},[_c('circle',{attrs:{"fill":"#CDCDCD","cx":"15","cy":"15","r":"15"}}),_c('g',{attrs:{"stroke":"#6F6F6F"}},[_c('path',{attrs:{"d":"M6 24.5L3.5 23l7.5-5-1-6c2-5.333 3.5-8.167 4.5-8.5V19c0 .333-.167.833-.5 1.5-.333.667-1.333 1.833-3 3.5l-2 2.5-3-2z","fill":"#FFF"}}),_c('path',{attrs:{"d":"M13 14c0-2.333.667-3.5 2-3.5M12 11c1-2.667 2-4 3-4"}})]),_c('g',{attrs:{"stroke":"#6F6F6F"}},[_c('path',{attrs:{"d":"M24 24.5l2.5-1.5-7.5-5 1-6c-2-5.333-3.5-8.167-4.5-8.5V19c0 .333.167.833.5 1.5.333.667 1.333 1.833 3 3.5l2 2.5 3-2z","fill":"#FFF"}}),_c('path',{attrs:{"d":"M17 14c0-2.333-.667-3.5-2-3.5M18 11c-1-2.667-2-4-3-4"}})]),_c('path',{attrs:{"fill":"#6F6F6F","d":"M9 19.5l3.5 2.5L9 26.5 4 23zM20.5 19.5L17 22l3.5 4.5L26 23z"}})])])
          )
        }
      }
    